
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kBOGD", function(module, exports) {

$parcel$export(module.exports, "CreateComponent", () => $433f7c954f8755e5$export$a9a76753cd947d5c);
/* CreateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $3gadb = parcelRequire("3gadb");

var $7zgzO = parcelRequire("7zgzO");

var $de2j9 = parcelRequire("de2j9");

var $O7CpO = parcelRequire("O7CpO");

var $jKIuI = parcelRequire("jKIuI");

var $1NBp8 = parcelRequire("1NBp8");

var $ljm2R = parcelRequire("ljm2R");

var $bZSO8 = parcelRequire("bZSO8");
var $gPB5e = parcelRequire("gPB5e");
var $aQZ08 = parcelRequire("aQZ08");
var $eTign = parcelRequire("eTign");
var $jqe2L = parcelRequire("jqe2L");
var $94z7g = parcelRequire("94z7g");

var $7EIq6 = parcelRequire("7EIq6");

var $55rla = parcelRequire("55rla");

var $lJxO6 = parcelRequire("lJxO6");

var $l5Slu = parcelRequire("l5Slu");

var $1BYn9 = parcelRequire("1BYn9");

var $8fj5s = parcelRequire("8fj5s");

var $dEBDF = parcelRequire("dEBDF");

var $5cryL = parcelRequire("5cryL");

var $ivb8S = parcelRequire("ivb8S");

var $fywGr = parcelRequire("fywGr");

var $ep3mz = parcelRequire("ep3mz");

var $7yn0t = parcelRequire("7yn0t");

var $kDja4 = parcelRequire("kDja4");

var $yuLaV = parcelRequire("yuLaV");
var $6MlZq = parcelRequire("6MlZq");

var $bqyIi = parcelRequire("bqyIi");

var $hqD0X = parcelRequire("hqD0X");

var $gIdnC = parcelRequire("gIdnC");

var $lqy4C = parcelRequire("lqy4C");

var $gz8ZY = parcelRequire("gz8ZY");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $efvKr = parcelRequire("efvKr");

var $gTyTP = parcelRequire("gTyTP");

var $7aRa9 = parcelRequire("7aRa9");

var $6g41Q = parcelRequire("6g41Q");

var $iGpKB = parcelRequire("iGpKB");
const $433f7c954f8755e5$var$containerStyles = null;

const $433f7c954f8755e5$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZXF2b",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("gfjK8"))).CreateButton
});
const $433f7c954f8755e5$var$LIVE_DOCS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $433f7c954f8755e5$var$CreateComponentContent = ({ flags: flags })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { setQueryParams: setQueryParams, match: match, push: push, location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isCreationDropdownEnabled = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-component'
    });
    const [areKeyboardShortcutsEnabled] = (0, $ljm2R.useKeyboardShortcutsState)();
    const isDatabaseEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isCreateContentPage = Boolean((0, $1NBp8.CREATE_CONTENT).match(location?.pathname || ''));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey); // Whiteboard GA
    const [isWhiteboardGASpotlightEnabled, setIsWhiteboardGASpotlightEnabled] = (0, $gwFzn.useState)(false); // GA onboarding is enabled + NOT on editor route + NOT on create-content route
    // Exclude the editor route to avoid disrupting a user's workflow when they're actively creating
    // Exclude the create-content route because it can quickly redirect and we don't want modal screen events firing twice
    const showWhiteboardGAOnboardingModal = isWhiteboardGAOnboardingEnabled() && !isOnEditRoute && !isCreateContentPage;
    const [hasStartedWhiteboardGAOnboardingCoordination, stopWhiteboardGAOnboardingCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-whiteboards-ga-admin-onboarding-modal', !showWhiteboardGAOnboardingModal);
    const onCloseWhiteboardGAOnboardingModal = (0, $gwFzn.useCallback)(()=>{
        stopWhiteboardGAOnboardingCoordination();
        setIsWhiteboardGASpotlightEnabled(true);
    }, [
        setIsWhiteboardGASpotlightEnabled,
        stopWhiteboardGAOnboardingCoordination
    ]);
    const onCloseWhiteboardGASpotlight = (0, $gwFzn.useCallback)(()=>{
        setIsWhiteboardGASpotlightEnabled(false);
    }, [
        setIsWhiteboardGASpotlightEnabled
    ]);
    const [hasStartedLoomPremigrationModalCoordination, stopLoomPremigrationModalCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-content-types-loom-premigration-modal', !(0, $9wGTI.fg)('confluence_loom_premigration_modal'));
    const onCloseLoomPremigrationModal = (0, $gwFzn.useCallback)(()=>{
        stopLoomPremigrationModalCoordination();
    }, [
        stopLoomPremigrationModalCoordination
    ]);
    const [hasStartedLoomMigrationModalCoordination, stopLoomMigrationModalCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-content-types-loom-migration-modal', !(0, $9wGTI.fg)('confluence_loom_migration_modal'));
    const onCloseLoomMigrationModal = (0, $gwFzn.useCallback)(()=>{
        stopLoomMigrationModalCoordination();
    }, [
        stopLoomMigrationModalCoordination
    ]);
    const showDatabaseGAOnboardingModal = isDatabaseEnabled && isProductAdmin && !isOnEditRoute && !isCreateContentPage;
    const [hasStartedDatabaseGAOnboardingCoordination, stopDatabaseGAOnboardingCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-databases-ga-admin-onboarding-modal', !showDatabaseGAOnboardingModal);
    const onCloseDatabaseGAOnboardingModal = (0, $gwFzn.useCallback)(()=>{
        stopDatabaseGAOnboardingCoordination();
    }, [
        stopDatabaseGAOnboardingCoordination
    ]);
    const { isEnabled: isOnboardingNewHomeTakeoverEnabled } = (0, $gIdnC.useOnboardingNewHomeTakeoverEnabled)();
    const { setEditSource: setEditSource } = (0, $O7CpO.useEditSourceActions)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)
    }), !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = (0, $ivb8S.deserializeState)(data);
    const fireAnalytics = (additionalAttributes = {})=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'create',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH),
                    ...additionalAttributes
                }
            }
        }).fire();
    };
    const openCreateDialog = ()=>{
        fireAnalytics();
        setQueryParams({
            createDialog: true
        });
    };
    const shouldCreateBlankFabricPage = ()=>{
        if (data && editorOnboardingEligiblity) (0, $fywGr.preloadEditorOnboardingState)();
        return true;
    };
    const createPageHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: 'createBlankFabricPage',
        withFallback: true,
        spaceKey: spaceKey,
        parentPageId: contentId
    });
    const handleCreatePageShortcut = ()=>{
        setEditSource((0, $jKIuI.CREATE_PAGE_SHORTCUT));
        fireAnalytics({
            keyboardShortcut: true
        });
        const shouldCreate = shouldCreateBlankFabricPage();
        if (shouldCreate) push(createPageHref);
    };
    const handleCreatePageButtonClick = (e)=>{
        fireAnalytics();
        const shouldCreate = shouldCreateBlankFabricPage();
        if (shouldCreate) {
            if (isNav4Enabled) {
                if (e.metaKey || e.ctrlKey) window.open(createPageHref, '_blank', 'noreferrer');
                else push(createPageHref);
            }
        } else // creation is handled by href for button click
        e.preventDefault();
    };
    const createBlog = ()=>{
        const createBlogLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'blog',
            source: 'globalCreateBlogShortcut',
            spaceKey: spaceKey
        });
        push(createBlogLink);
    };
    const createLiveDoc = ()=>{
        const createLiveDocLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: (0, $gPB5e.ConfluencePageSubType).LIVE,
            parentPageId: contentId,
            withFallback: true,
            source: 'globalCreateLiveDocShortcut',
            spaceKey: spaceKey
        });
        push(createLiveDocLink);
    };
    const showLiveDocNotEnabledFlag = ()=>{
        flags.showErrorFlag({
            id: 'live-doc-not-enabled-shortcut-flag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledAction),
                    onClick: ()=>{
                        window.open($433f7c954f8755e5$var$LIVE_DOCS_LINK, '_blank');
                    }
                }
            ]
        });
    };
    const getButtonHref = ()=>{
        if ((0, $jqe2L.isCreateBlankFabricPageEnabled)() && !shouldBlockCreate) return createPageHref;
        return undefined;
    };
    const [createPageClickListener, createPageShortcutListener] = (0, $jqe2L.isCreateBlankFabricPageEnabled)() ? [
        handleCreatePageButtonClick,
        handleCreatePageShortcut
    ] : [
        openCreateDialog,
        openCreateDialog
    ]; /**
                                                                                                                                                                                                     * Please also update skeleton in appNavigationLazyItems
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * <NavItemWrapper>
                                                                                                                                                                                                        <CreateButton />
                                                                                                                                                                                                      </NavItemWrapper>
                                                                                                                                                                                                     */ 
    const EngagementInlineDialogLoader = isNav4Enabled ? (0, $6g41Q.EngagementInlineDialogLoader) : (0, $6g41Q.EngagementInlineDialogLoaderNav3);
    const globalCreateContentPopover = (0, $gwFzn.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('navx_universal_create_experiment', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $94z7g.UniversalCreate), null);
        if (hasStartedWhiteboardGAOnboardingCoordination || isWhiteboardGASpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
            target: (0, $hqD0X.HOVER_TARGET).CREATE,
            shouldWrap: isOnboardingNewHomeTakeoverEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eTign.GlobalCreateContentPopoverSpotlightLoader), {
            isGA: true,
            spotlightEnabled: isWhiteboardGASpotlightEnabled,
            onSpotlightClose: onCloseWhiteboardGASpotlight
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
            target: (0, $hqD0X.HOVER_TARGET).CREATE,
            shouldWrap: isOnboardingNewHomeTakeoverEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aQZ08.GlobalCreateContentPopover), null));
    }, [
        isOnboardingNewHomeTakeoverEnabled,
        hasStartedWhiteboardGAOnboardingCoordination,
        isWhiteboardGASpotlightEnabled,
        onCloseWhiteboardGASpotlight
    ]);
    const universalGlobalCreateShortcut = (0, $ljm2R.isMac)() ? (0, $ljm2R.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC) : (0, $ljm2R.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "app-navigation-create",
        "data-pendo-id": "con-*/wiki/home-create",
        "data-vc": "create-component",
        ...ssrPlaceholderIdProp,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(EngagementInlineDialogLoader, {
        engagementId: "createComponentButton",
        dataVC: "app-navigation-create-engagement-inline-dialog"
    }, isCreationDropdownEnabled ? globalCreateContentPopover() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: areKeyboardShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: universalGlobalCreateShortcut,
            isTooltip: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7yn0t.CreateContentButtonPreloader), {
        editSource: (0, $jKIuI.CREATE_NAV_BUTTON_CLICK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
        target: (0, $hqD0X.HOVER_TARGET).CREATE,
        shouldWrap: isOnboardingNewHomeTakeoverEnabled
    }, isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($433f7c954f8755e5$var$CreateButton, {
        onClick: enforceStorageLimit(createPageClickListener)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $433f7c954f8755e5$var$i18n.create)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iGpKB.CreateButton), {
        onClick: enforceStorageLimit(createPageClickListener),
        href: getButtonHref()
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.GLOBAL_CREATE_SHORTCUT) : undefined,
        accelerator: universalGlobalCreateShortcut,
        listener: enforceStorageLimit(createPageShortcutListener),
        isAppNavigationShortcut: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.BLOG_SHORTCUT) : undefined,
        accelerator: (0, $ljm2R.UNIVERSAL_BLOG_SHORTCUT),
        listener: enforceStorageLimit(createBlog),
        isAppNavigationShortcut: true
    }), isCreateLiveDocEnabled && isLivePagesFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: (0, $ljm2R.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(createLiveDoc),
        isAppNavigationShortcut: true
    }), !isCreateLiveDocEnabled && isLivePagesFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: (0, $ljm2R.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(showLiveDocNotEnabledFlag),
        isAppNavigationShortcut: true
    }), showWhiteboardGAOnboardingModal && hasStartedWhiteboardGAOnboardingCoordination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $55rla.WhiteboardGAModalManager), {
        onClose: onCloseWhiteboardGAOnboardingModal,
        parentId: contentId,
        spaceKey: spaceKey
    }), // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasStartedLoomPremigrationModalCoordination && (0, $9wGTI.fg)('confluence_loom_beta_enabled') && (0, $9wGTI.fg)('confluence_loom_premigration_modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lJxO6.LoomMigrationModalManager), {
        isPremigration: true,
        onClose: onCloseLoomPremigrationModal
    }), hasStartedLoomMigrationModalCoordination && // Migration
    // This feature gate has the rule: `loombetaprovision` none of `migrated-site` => 100% fail
    // since there not a different feature gate to let us know if the user is migrated
    (0, $9wGTI.fg)('confluence_loom_migration_modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lJxO6.LoomMigrationModalManager), {
        onClose: onCloseLoomMigrationModal
    }), showDatabaseGAOnboardingModal && hasStartedDatabaseGAOnboardingCoordination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l5Slu.DatabaseGAOnboardingModalManager), {
        onClose: onCloseDatabaseGAOnboardingModal,
        parentId: contentId,
        spaceKey: spaceKey
    }));
};
const $433f7c954f8755e5$var$i18n = (0, $2nPZH.defineMessages)({
    create: {
        id: "app-navigation.top-navigation.create",
        defaultMessage: "Create"
    },
    liveDocsNotEnabledTitle: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.title",
        defaultMessage: "Live docs aren\u2019t enabled in this space"
    },
    liveDocsNotEnabledDescription: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.description",
        defaultMessage: "To use this shortcut, your space admin will need to enable live docs."
    },
    liveDocsNotEnabledAction: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.action",
        defaultMessage: "Find out more"
    }
});
const $433f7c954f8755e5$export$a9a76753cd947d5c = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $gwFzn.memo)($433f7c954f8755e5$var$CreateComponentContent));

});
parcelRegister("94z7g", function(module, exports) {

$parcel$export(module.exports, "UniversalCreate", () => $f44feda85e5453ef$export$b8b0dfc3e3d56c92);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $jdIYP = parcelRequire("jdIYP");

var $7aRa9 = parcelRequire("7aRa9");

var $9wGTI = parcelRequire("9wGTI");

var $dEBDF = parcelRequire("dEBDF");

var $lBYCH = parcelRequire("lBYCH");

var $dIouf = parcelRequire("dIouf");

var $de2j9 = parcelRequire("de2j9");

var $7zgzO = parcelRequire("7zgzO");

var $gz8ZY = parcelRequire("gz8ZY");

var $3J7nf = parcelRequire("3J7nf");

var $6e99h = parcelRequire("6e99h");
const $f44feda85e5453ef$var$messages = (0, $2nPZH.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = ({ flags: flags })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const items = (0, $6e99h.useMenuItems)(flags, ()=>setIsOpen(false));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { introSpotlight: { isVisible: introSpotlightVisible } } = (0, $3J7nf.useLiveDocChangeboarding)();
    const buttonTheme = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
    const onCreateClick = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'globalCreateContentPopover',
                source: 'globalNavigation',
                attributes: {
                    selectedItemPageContext: match?.name,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $dEBDF.START),
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isNav4Enabled,
        isOnEditRoute,
        match?.name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jdIYP.default), {
        items: items,
        onClick: onCreateClick,
        triggerButtonSpotlightTarget: "top-nav-create",
        enableTriggerPulse: false,
        isNav4Enabled: isNav4Enabled,
        isOpen: isOpen,
        product: "confluence",
        buttonTheme: buttonTheme,
        testId: "create-content-popover-button",
        preventClose: introSpotlightVisible && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding')
    }, formatMessage($f44feda85e5453ef$var$messages.create));
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).NAVX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
}

});
parcelRegister("jdIYP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ddd708270831c0a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $lGgRw = parcelRequire("lGgRw");

var $gWF6I = parcelRequire("gWF6I");

var $aCLzh = parcelRequire("aCLzh");

var $VSkIN = parcelRequire("VSkIN");

var $7Kxia = parcelRequire("7Kxia");

var $etnZD = parcelRequire("etnZD");

var $lz3e7 = parcelRequire("lz3e7");
function $4ddd708270831c0a$export$5c89068caaa33f77({ children: children, items: items, testId: testId, shouldRenderToParent: shouldRenderToParent, onClick: onClick, onClose: onClose, selectedItem: selectedItem, product: product, isOpen: controlledOpen = false, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, preventClose: preventClose = false, suggestionConfig: suggestionConfig = {
    enabled: false
} }) {
    const isResponsive = (0, $lz3e7.useIsResponsiveView)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(controlledOpen || false);
    const structuredItems = (0, $VSkIN.useNormalizeItems)(items);
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { items: crossAppItems, fetchData: fetchData } = (0, $aCLzh.useUniversalCreateApi)();
    const defaultMenu = (0, $gwFzn.useCallback)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7Kxia.default), {}), []);
    const [createContent, setCreateContent] = (0, $gwFzn.useState)(()=>defaultMenu);
    const reset = (0, $gwFzn.useCallback)(()=>{
        setCreateContent(()=>defaultMenu);
    }, [
        defaultMenu
    ]);
    const close = (0, $gwFzn.useCallback)(()=>{
        setCreateContent(()=>defaultMenu);
        setIsOpen(false);
    }, [
        defaultMenu
    ]);
    const load = (0, $gwFzn.useCallback)((loadCreateContent)=>{
        setCreateContent(()=>(contentProps)=>loadCreateContent(contentProps, {
                    reset: reset,
                    close: close
                }));
    }, [
        close,
        reset
    ]);
    const triggerButtonClick = (0, $gwFzn.useCallback)(()=>{
        setIsOpen((prev)=>{
            if (prev) onClose?.();
            crossAppCreationEnabled && fetchData();
            return !prev;
        });
        onClick?.();
    }, [
        onClick,
        onClose,
        setIsOpen,
        crossAppCreationEnabled,
        fetchData
    ]);
    const popupTrigger = (0, $gwFzn.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $etnZD.TriggerButton), {
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            isOpen: isOpen,
            onClick: triggerButtonClick,
            triggerProps: triggerProps,
            product: product,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme,
            children: children
        }), [
        children,
        enableTriggerPulse,
        isOpen,
        product,
        testId,
        triggerButtonClick,
        triggerButtonSpotlightTarget,
        buttonTheme,
        isNav4Enabled
    ]);
    const onCloseMenu = (0, $gwFzn.useCallback)(()=>{
        if (product === 'confluence' && preventClose) return;
        setIsOpen(false);
        setCreateContent(()=>defaultMenu);
        onClose?.();
    }, [
        defaultMenu,
        onClose,
        product,
        preventClose
    ]);
    const foundItem = (0, $gwFzn.useMemo)(()=>selectedItem && (0, $VSkIN.findSelectedItem)(structuredItems, selectedItem), [
        selectedItem,
        structuredItems
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen) {
            const loadContent = foundItem?.loadCreateContent;
            if (loadContent) setCreateContent(()=>(contentProps)=>loadContent(contentProps, {
                        reset: reset,
                        close: close
                    }));
            else reset();
        }
    }, [
        close,
        isOpen,
        foundItem?.loadCreateContent,
        reset
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (controlledOpen !== undefined) setIsOpen(controlledOpen);
    }, [
        controlledOpen
    ]);
    const loadContentWithRelayProvider = (0, $gwFzn.useCallback)((props)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gWF6I.ConditionalRelayEnvironmentProvider), {
            children: createContent(props)
        });
    }, [
        createContent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $VSkIN.MenuControlContext).Provider, {
        value: {
            reset: reset,
            close: close,
            load: load,
            mixedItems: structuredItems,
            product: product,
            crossAppItems: crossAppItems
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            placement: isResponsive && isNav4Enabled ? 'bottom-end' : 'bottom-start',
            shouldRenderToParent: shouldRenderToParent,
            onClose: onCloseMenu,
            content: loadContentWithRelayProvider,
            trigger: popupTrigger
        })
    });
}
var $4ddd708270831c0a$export$2e2bcd8739ae039 = $4ddd708270831c0a$export$5c89068caaa33f77;

});
parcelRegister("aCLzh", function(module, exports) {

$parcel$export(module.exports, "useUniversalCreateApi", () => $947108f922dbe70e$export$b55301a715ba654d);

var $gwFzn = parcelRequire("gwFzn");

var $jjCkw = parcelRequire("jjCkw");

var $da08N = parcelRequire("da08N");
function $947108f922dbe70e$var$getHomeUrl() {
    return new URL(window.location.href).origin;
}
function $947108f922dbe70e$export$b55301a715ba654d() {
    const [items, setItems] = (0, $gwFzn.useState)([]);
    const fetched = (0, $gwFzn.useRef)(false);
    const fetchData = (0, $gwFzn.useCallback)(()=>{
        const url = `${$947108f922dbe70e$var$getHomeUrl()}${(0, $jjCkw.UC_AVAILABLE_ACTIONS_URL_PATH)}`;
        if (!fetched.current) fetch(url, {
            credentials: 'include'
        }).then(async (res)=>{
            const response = await res.json();
            if (response?.items) {
                const transformedItems = await (0, $da08N.transformItems)(response.items);
                setItems(transformedItems);
                fetched.current = true;
            }
            return;
        }).catch((error)=>{
            throw error;
        });
        return;
    }, []);
    return {
        items: items,
        fetchData: fetchData
    };
}

});
parcelRegister("jjCkw", function(module, exports) {

$parcel$export(module.exports, "TRIGGER_BUTTON_TEST_ID", () => $38e5614694cf6bb5$export$3f4cc858c0cb6e84);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $38e5614694cf6bb5$export$85183a312807388d);
$parcel$export(module.exports, "MAX_ALLOWED_SECTIONS", () => $38e5614694cf6bb5$export$4e49778ae689b92a);
$parcel$export(module.exports, "UC_AVAILABLE_ACTIONS_URL_PATH", () => $38e5614694cf6bb5$export$23a04b50d4d31d04);
const $38e5614694cf6bb5$export$373682275c03fc63 = 'universal-create';
const $38e5614694cf6bb5$export$4fbca0e866deff63 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button-target`;
const $38e5614694cf6bb5$export$3f4cc858c0cb6e84 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button`;
const $38e5614694cf6bb5$export$85183a312807388d = 'navigation';
const $38e5614694cf6bb5$export$4e49778ae689b92a = 3;
const $38e5614694cf6bb5$export$23a04b50d4d31d04 = '/gateway/api/app-switcher/api/universal-create/v1/available-objects';

});

parcelRegister("da08N", function(module, exports) {

$parcel$export(module.exports, "transformItems", () => $bfd23a0d8b3c6878$export$f8e983a9ac6ba971);

var $gJsgh = parcelRequire("gJsgh");

var $8jHAi = parcelRequire("8jHAi");

var $1dKyn = parcelRequire("1dKyn");

var $2qVkt = parcelRequire("2qVkt");

var $3w0K2 = parcelRequire("3w0K2");
async function $bfd23a0d8b3c6878$var$loadIcon(iconName) {
    try {
        if (!iconName) return undefined;
        if (iconName === '__mock-icon--work-item') return 0, (/*@__PURE__*/$parcel$interopDefault($2qVkt));
        if (iconName === '__mock-icon--page') return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
        if (iconName === '__mock-icon--goals') return 0, (/*@__PURE__*/$parcel$interopDefault($gJsgh));
        if (iconName === '__mock-icon--team') return 0, (/*@__PURE__*/$parcel$interopDefault($1dKyn));
        const iconModule = await import(/* webpackIgnore: true */ `@atlaskit/icon/core/${iconName}`);
        return iconModule.default;
    } catch (error) {
        console.error(`Failed to load icon: ${iconName}`, error);
        return undefined;
    }
}
async function $bfd23a0d8b3c6878$export$f8e983a9ac6ba971(items) {
    return await Promise.all(items.map(async (responseItem)=>{
        const Icon = responseItem.icon ? await $bfd23a0d8b3c6878$var$loadIcon(responseItem.icon) : undefined;
        const itemBase = {
            ati: (0, $3w0K2.Ati).parse(responseItem.ati),
            children: responseItem.name,
            elemBefore: Icon,
            testId: `remote-item-${responseItem.ati}`,
            product: responseItem.product
        };
        if (responseItem.type === 'integration') {
            const integrationItem = {
                ...itemBase,
                type: responseItem.type,
                actionType: responseItem.actionType
            };
            return integrationItem;
        } else {
            const item = {
                ...itemBase,
                type: responseItem.type
            };
            return item;
        }
    }));
}

});


parcelRegister("VSkIN", function(module, exports) {

$parcel$export(module.exports, "useNormalizeItems", () => $d27513c3e3d1447c$export$badb391c957852f7);
$parcel$export(module.exports, "findSelectedItem", () => $d27513c3e3d1447c$export$5a8ab32aeea5694f);
$parcel$export(module.exports, "filterCrossAppItems", () => $d27513c3e3d1447c$export$49016bfbe31ae62d);
$parcel$export(module.exports, "MenuControlContext", () => $d27513c3e3d1447c$export$39aa3c8950714d79);
$parcel$export(module.exports, "useMenuControl", () => $d27513c3e3d1447c$export$56d95dc846453c64);

var $gwFzn = parcelRequire("gwFzn");
function $d27513c3e3d1447c$export$270a88864b52a4aa(items) {
    if (Array.isArray(items)) return items.every((item)=>{
        return typeof item === 'object' && item !== null && 'ati' in item;
    });
    return false;
}
function $d27513c3e3d1447c$export$badb391c957852f7(items) {
    const mixedItems = [];
    if ($d27513c3e3d1447c$export$270a88864b52a4aa(items)) mixedItems.push({
        items: items
    });
    else mixedItems.push(...items);
    return mixedItems;
}
function $d27513c3e3d1447c$export$5a8ab32aeea5694f(items, selectedItem) {
    for (const namedItem of items)for (const menuItem of namedItem.items){
        if (menuItem.ati.toString() === selectedItem.toString()) return menuItem;
    }
    return null;
}
function $d27513c3e3d1447c$export$49016bfbe31ae62d(product, crossAppItems) {
    return crossAppItems?.filter((item)=>item.product !== product);
}
const $d27513c3e3d1447c$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {},
    mixedItems: [],
    product: 'jira',
    crossAppItems: []
};
const $d27513c3e3d1447c$export$39aa3c8950714d79 = /*#__PURE__*/ (0, $gwFzn.createContext)($d27513c3e3d1447c$var$defaultFormControls);
function $d27513c3e3d1447c$export$56d95dc846453c64() {
    return (0, $gwFzn.useContext)($d27513c3e3d1447c$export$39aa3c8950714d79);
}

});

parcelRegister("7Kxia", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e089b4dea2b2c3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1Whri = parcelRequire("1Whri");

var $9VJDA = parcelRequire("9VJDA");

var $56M4r = parcelRequire("56M4r");
var $2SlZp = parcelRequire("2SlZp");

var $iZRoG = parcelRequire("iZRoG");
var $2KDGn = parcelRequire("2KDGn");
var $2bhek = parcelRequire("2bhek");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $jjCkw = parcelRequire("jjCkw");

var $fNh3C = parcelRequire("fNh3C");

var $VSkIN = parcelRequire("VSkIN");

var $jy2To = parcelRequire("jy2To");
const $a1e089b4dea2b2c3$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc",
    itemWrap: "_19bvu2gc _u5f3u2gc",
    textStyle: "_k48p1wq8 _ect41gqc _syaz1gjq"
};
const $a1e089b4dea2b2c3$var$MAX_ITEMS = 10;
const $a1e089b4dea2b2c3$var$MIN_ITEMS = 4;
const $a1e089b4dea2b2c3$var$showMoreButtonWrap = null;
const $a1e089b4dea2b2c3$var$messages = (0, $2nPZH.defineMessages)({
    showMore: {
        id: "platform.navigation-experiences.universal-create.show-more",
        defaultMessage: "More"
    },
    showLess: {
        id: "platform.navigation-experiences.universal-create.show-less",
        defaultMessage: "Less"
    },
    remoteSectionHeading: {
        id: "platform.navigation-experiences.universal-create.remote-section-heading",
        defaultMessage: "Suggestions"
    }
});
function $a1e089b4dea2b2c3$var$MenuContent() {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { mixedItems: mixedItems, product: product, crossAppItems: crossAppItems } = (0, $gwFzn.useContext)((0, $VSkIN.MenuControlContext));
    const transformedCrossAppItems = (0, $gwFzn.useMemo)(()=>{
        const filteredCrossAppItems = (0, $VSkIN.filterCrossAppItems)(product, crossAppItems);
        const items = filteredCrossAppItems?.map((item)=>({
                ...item,
                loadCreateContent: ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                        children: [
                            item.children,
                            " dummy form"
                        ]
                    })
            }));
        return items;
    }, [
        crossAppItems,
        product
    ]);
    const allowedItems = (0, $gwFzn.useMemo)(()=>{
        const items = mixedItems.slice(0, (0, $jjCkw.MAX_ALLOWED_SECTIONS));
        if (crossAppCreationEnabled && transformedCrossAppItems?.length && transformedCrossAppItems.length > 0) items.push({
            heading: formatMessage($a1e089b4dea2b2c3$var$messages.remoteSectionHeading),
            items: transformedCrossAppItems,
            foldable: true
        });
        return items;
    }, [
        formatMessage,
        crossAppCreationEnabled,
        mixedItems,
        transformedCrossAppItems
    ]);
    const [showAll, setShowAll] = (0, $gwFzn.useState)(false);
    const text = showAll ? formatMessage($a1e089b4dea2b2c3$var$messages.showLess) : formatMessage($a1e089b4dea2b2c3$var$messages.showMore);
    const handleShowMore = (0, $gwFzn.useCallback)(()=>{
        setShowAll((prev)=>!prev);
    }, [
        setShowAll
    ]);
    const renderItems = (0, $gwFzn.useCallback)((items, foldable)=>{
        if (!foldable || items.length <= $a1e089b4dea2b2c3$var$MIN_ITEMS) return items;
        return items.slice(0, showAll ? $a1e089b4dea2b2c3$var$MAX_ITEMS : $a1e089b4dea2b2c3$var$MIN_ITEMS);
    }, [
        showAll
    ]);
    const restProps = {
        className: 'custom-item-wrapper-style'
    };
    if (!allowedItems?.length) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2SlZp.default), {
        spacing: "compact",
        testId: "global-create-content-popover-menu",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a1e089b4dea2b2c3$var$styles.menuWrap),
            children: allowedItems.map((namedItem, sectionIndex)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2KDGn.MenuSection), {
                            children: [
                                namedItem.heading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($a1e089b4dea2b2c3$var$styles.itemWrap),
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2bhek.MenuSectionHeading), {
                                        children: namedItem.heading
                                    })
                                }),
                                renderItems(namedItem.items, namedItem.foldable).map((menuItem, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $jy2To.default), {
                                        item: menuItem
                                    }, `menu-section-${sectionIndex}-item-${index}`)),
                                namedItem.foldable && namedItem.items.length > $a1e089b4dea2b2c3$var$MIN_ITEMS && /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                    className: (0, $35pXk.default)([
                                        "_19bvu2gc _u5f3u2gc _148a1y44 _14blu2gc _c4ghu2gc _1q3d1gjq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $56M4r.default), {
                                        ...restProps,
                                        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                                            label: "",
                                            color: "var(--ds-text-subtle)"
                                        }),
                                        onClick: handleShowMore,
                                        testId: "toggle-more-less-button",
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                            as: "span",
                                            xcss: $a1e089b4dea2b2c3$var$styles.textStyle,
                                            children: text
                                        })
                                    })
                                })
                            ]
                        }),
                        sectionIndex !== allowedItems.length - 1 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iZRoG.Divider), {}) : null
                    ]
                }, `menu-section-${sectionIndex}`))
        })
    });
}
var $a1e089b4dea2b2c3$export$2e2bcd8739ae039 = (0, $fNh3C.withIntlProvider)($a1e089b4dea2b2c3$var$MenuContent);

});
parcelRegister("fNh3C", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $503da3927b063db6$export$a5d940130f33be3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $keVvA = parcelRequire("keVvA");

var $innpZ = parcelRequire("innpZ");
function $503da3927b063db6$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $503da3927b063db6$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("puJbO"));
        case 'da':
            return (parcelRequire("jiJMU"));
        case 'de':
            return (parcelRequire("ZsK3j"));
        case 'en-GB':
            return (parcelRequire("RJS8A"));
        case 'en-ZZ':
            return (parcelRequire("bKnda"));
        case 'en':
            return Promise.resolve((parcelRequire("innpZ")));
        case 'es':
            return (parcelRequire("dO82Z"));
        case 'fi':
            return (parcelRequire("9EMKJ"));
        case 'fr':
            return (parcelRequire("bAAgF"));
        case 'hu':
            return (parcelRequire("jn4rt"));
        case 'it':
            return (parcelRequire("bdeSu"));
        case 'ja':
            return (parcelRequire("hbWjw"));
        case 'ko':
            return (parcelRequire("hetkt"));
        case 'nb':
            return (parcelRequire("5cg9d"));
        case 'nl':
            return (parcelRequire("hrdPU"));
        case 'pl':
            return (parcelRequire("iovDN"));
        case 'pt':
            return (parcelRequire("iVen3"));
        case 'ru':
            return (parcelRequire("ffizh"));
        case 'sv':
            return (parcelRequire("gFReN"));
        case 'th':
            return (parcelRequire("gL45G"));
        case 'tr':
            return (parcelRequire("oIMxC"));
        case 'uk':
            return (parcelRequire("5bXdA"));
        case 'vi':
            return (parcelRequire("hLqxl"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("fV1hC"));
        case 'zh':
            return (parcelRequire("5pkry"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $503da3927b063db6$export$12346a674644c156 = 'operational';
const $503da3927b063db6$export$515664faa1398f37 = 'navigation';
function $503da3927b063db6$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $503da3927b063db6$var$fetchLanguageFile($503da3927b063db6$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $503da3927b063db6$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($503da3927b063db6$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $innpZ.default),
        children: children
    });
}
const $503da3927b063db6$export$a5d940130f33be3f = (WrappedComponent)=>()=>/*#__PURE__*/ (0, $7UHDa.jsx)($503da3927b063db6$var$Provider, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {})
        });

});
parcelRegister("innpZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $be8cd34b8beefeb9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $be8cd34b8beefeb9$export$2e2bcd8739ae039 = {
    VzzYJk: 'Create',
    'navigation.universal-create.menuItemLoading': 'Menu item is loading',
    'platform.navigation-experiences.universal-create.remote-section-heading': 'Suggestions',
    'platform.navigation-experiences.universal-create.show-less': 'Less',
    'platform.navigation-experiences.universal-create.show-more': 'More'
};

});

parcelRegister("puJbO", function(module, exports) {

let $04ca2bd3dc8972f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $04ca2bd3dc8972f9$var$load("kr1hG").then(()=>parcelRequire('681mP'));

});

parcelRegister("jiJMU", function(module, exports) {

let $e0d33749233b43c0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e0d33749233b43c0$var$load("ins06").then(()=>parcelRequire('20uOS'));

});

parcelRegister("ZsK3j", function(module, exports) {

let $0b8bfe2392b55560$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b8bfe2392b55560$var$load("9vQGB").then(()=>parcelRequire('cFvgI'));

});

parcelRegister("RJS8A", function(module, exports) {

let $0a18889cdb60d548$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0a18889cdb60d548$var$load("kaLOH").then(()=>parcelRequire('9gNwe'));

});

parcelRegister("bKnda", function(module, exports) {

let $88d5fee245c5fc5d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $88d5fee245c5fc5d$var$load("bF0Yj").then(()=>parcelRequire('3wpz4'));

});

parcelRegister("dO82Z", function(module, exports) {

let $a0d62fe67cf57f3c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a0d62fe67cf57f3c$var$load("iTdzs").then(()=>parcelRequire('4iDME'));

});

parcelRegister("9EMKJ", function(module, exports) {

let $707daabe78a25ac0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $707daabe78a25ac0$var$load("5Tak1").then(()=>parcelRequire('f8ubb'));

});

parcelRegister("bAAgF", function(module, exports) {

let $86ff308cb11b088b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $86ff308cb11b088b$var$load("7NfA4").then(()=>parcelRequire('aKfhH'));

});

parcelRegister("jn4rt", function(module, exports) {

let $e1a39c6b4fc89731$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e1a39c6b4fc89731$var$load("5Psde").then(()=>parcelRequire('fvbZZ'));

});

parcelRegister("bdeSu", function(module, exports) {

let $829c73104cf52031$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $829c73104cf52031$var$load("k90B6").then(()=>parcelRequire('j2Gbi'));

});

parcelRegister("hbWjw", function(module, exports) {

let $c840b2aa62700293$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c840b2aa62700293$var$load("98bRK").then(()=>parcelRequire('27yeK'));

});

parcelRegister("hetkt", function(module, exports) {

let $c8ba7ea5fcb8999b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c8ba7ea5fcb8999b$var$load("gePdq").then(()=>parcelRequire('8usxn'));

});

parcelRegister("5cg9d", function(module, exports) {

let $3c8a9950aaf94362$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c8a9950aaf94362$var$load("6eObS").then(()=>parcelRequire('kLzB7'));

});

parcelRegister("hrdPU", function(module, exports) {

let $cb1fb0de62d31ff3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cb1fb0de62d31ff3$var$load("cvIfq").then(()=>parcelRequire('jZNxH'));

});

parcelRegister("iovDN", function(module, exports) {

let $d6430320b6ccf818$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d6430320b6ccf818$var$load("aDvHP").then(()=>parcelRequire('9MD8s'));

});

parcelRegister("iVen3", function(module, exports) {

let $dc68b2a032e4b260$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dc68b2a032e4b260$var$load("fih2D").then(()=>parcelRequire('lywXu'));

});

parcelRegister("ffizh", function(module, exports) {

let $b196a8f97bdd3451$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b196a8f97bdd3451$var$load("2IvvO").then(()=>parcelRequire('4Blfb'));

});

parcelRegister("gFReN", function(module, exports) {

let $c239c591da2a1c24$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c239c591da2a1c24$var$load("dQMD4").then(()=>parcelRequire('jcm12'));

});

parcelRegister("gL45G", function(module, exports) {

let $c3343574fd81456d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3343574fd81456d$var$load("epSPI").then(()=>parcelRequire('81N3N'));

});

parcelRegister("oIMxC", function(module, exports) {

let $04a4fac35f9bcd07$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $04a4fac35f9bcd07$var$load("e2RXi").then(()=>parcelRequire('iu4P9'));

});

parcelRegister("5bXdA", function(module, exports) {

let $3c7bea4de1d4fecb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c7bea4de1d4fecb$var$load("iNX42").then(()=>parcelRequire('hB4yo'));

});

parcelRegister("hLqxl", function(module, exports) {

let $ceeb691f13fa7075$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ceeb691f13fa7075$var$load("asamZ").then(()=>parcelRequire('976jm'));

});

parcelRegister("fV1hC", function(module, exports) {

let $b96d2cb4343f56e7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b96d2cb4343f56e7$var$load("8X3OG").then(()=>parcelRequire('aTmmM'));

});

parcelRegister("5pkry", function(module, exports) {

let $3eff253071d1a3f8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3eff253071d1a3f8$var$load("3pTtv").then(()=>parcelRequire('4nb7z'));

});


parcelRegister("jy2To", function(module, exports) {

$parcel$export(module.exports, "default", () => $484ab491ea2642e6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $aPgM3 = parcelRequire("aPgM3");

var $lnHWt = parcelRequire("lnHWt");

var $56M4r = parcelRequire("56M4r");
var $cGtPE = parcelRequire("cGtPE");

var $iXCQx = parcelRequire("iXCQx");

var $3gadb = parcelRequire("3gadb");

var $VSkIN = parcelRequire("VSkIN");

var $j4qan = parcelRequire("j4qan");
const $484ab491ea2642e6$var$customItemStyles = null;
const $484ab491ea2642e6$var$textStyle = null; // Function to check if the element's text is truncated
function $484ab491ea2642e6$var$isTextClamped(labelElement, boxElement) {
    return labelElement.scrollWidth > boxElement.scrollWidth;
}
const $484ab491ea2642e6$var$Item = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ onClick: onClick, isLoading: isLoading, loadCreateContent: createContent, onClickCloseMenu: onClickCloseMenu = true, children: children, testId: testId, isDisabled: isDisabled, href: href, target: target, elemBefore: elemBefore, Wrapper: Wrapper }, forwardRef)=>{
    const menuControl = (0, $VSkIN.useMenuControl)();
    const labelRef = (0, $gwFzn.useRef)(null);
    const buttonClick = (0, $gwFzn.useCallback)((event)=>{
        if (createContent) menuControl.load(createContent);
        else if (onClickCloseMenu) menuControl.close();
        onClick?.(event);
    }, [
        menuControl,
        onClick,
        onClickCloseMenu,
        createContent
    ]);
    const renderButton = (0, $gwFzn.useCallback)((props)=>{
        const { triggerProps: triggerProps } = props || {};
        const { ref: triggerRef, ...restTriggerProps } = triggerProps || {};
        const Icon = elemBefore;
        const baseProps = {
            testId: testId,
            iconBefore: elemBefore && Icon ? /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                label: "",
                color: "var(--ds-text-subtle, #44546F)"
            }) : undefined,
            onClick: buttonClick,
            className: 'custom-item-style',
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    "_1t5c13mh _1t211l2s _1xdi1ule"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                    ref: labelRef,
                    maxLines: 1,
                    color: "color.text.subtle",
                    weight: "medium",
                    children: children
                })
            })
        };
        const canTooltipAppear = ()=>{
            return labelRef.current && mergedRef.current ? $484ab491ea2642e6$var$isTextClamped(labelRef.current, mergedRef.current) : false;
        };
        const mergedRef = (0, $lnHWt.mergeRefs)([
            ...forwardRef ? [
                forwardRef
            ] : [],
            ...triggerRef ? [
                triggerRef
            ] : []
        ]);
        const renderItem = (Item, props)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                content: children,
                canAppear: canTooltipAppear,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(Item, {
                    ...props
                })
            });
        };
        const linkProps = {
            ...baseProps,
            href: href,
            target: target,
            ...restTriggerProps,
            ...mergedRef && {
                ref: mergedRef
            }
        };
        const buttonProps = {
            ...baseProps,
            isDisabled: isDisabled,
            ...restTriggerProps,
            ...mergedRef && {
                ref: mergedRef
            }
        };
        return href ? renderItem((0, $cGtPE.default), linkProps) : renderItem((0, $56M4r.default), buttonProps);
    }, [
        testId,
        elemBefore,
        buttonClick,
        children,
        forwardRef,
        href,
        isDisabled,
        target
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j4qan.MenuSkeletonItem), {
        testId: `loading-${testId}`
    });
    if (Wrapper) return /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: (props)=>renderButton(props)
    });
    return renderButton();
});
function $484ab491ea2642e6$export$2e2bcd8739ae039({ item: item }) {
    const { ref: ref, ...props } = item;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                "_19bvu2gc _u5f3u2gc _1bsb163w _1gxw1y44 _18tmu2gc _uckdu2gc _14ujn7od"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($484ab491ea2642e6$var$Item, {
                ...props,
                ref: ref
            })
        })
    });
}

});
parcelRegister("j4qan", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonItem", () => $edce19e95b3a84ef$export$cde35cc9e1359709);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $eyWa4 = parcelRequire("eyWa4");

var $kpYGL = parcelRequire("kpYGL");

var $6F6hl = parcelRequire("6F6hl");

var $oq6Nl = parcelRequire("oq6Nl");
const $edce19e95b3a84ef$var$DEFAULT_MENU_SKELETON_HEIGHT = 40;
const $edce19e95b3a84ef$var$DEFAULT_AVATAR_HEIGHT = 20;
const $edce19e95b3a84ef$var$DEFAULT_CONTENT_HEIGHT = 9;
const $edce19e95b3a84ef$var$DEFAULT_BORDER_RADIUS = 3;
const $edce19e95b3a84ef$var$menuSkeletonStyles = {
    wrapper: "_4t3i1ylp _1bsb1osq _19bv1b66 _u5f31b66",
    avatar: "_19bvv77o"
};
const $edce19e95b3a84ef$export$cde35cc9e1359709 = ({ testId: testId, avatarHeight: avatarHeight = $edce19e95b3a84ef$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $edce19e95b3a84ef$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
        xcss: $edce19e95b3a84ef$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1s5hv.default), {
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $edce19e95b3a84ef$var$menuSkeletonStyles.avatar,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                            width: avatarHeight,
                            height: avatarHeight,
                            borderRadius: $edce19e95b3a84ef$var$DEFAULT_BORDER_RADIUS,
                            isShimmering: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                        width: "64%",
                        height: contentHeight,
                        isShimmering: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $oq6Nl.default).menuItemLoading)
            })
        ]
    });
};

});
parcelRegister("oq6Nl", function(module, exports) {

$parcel$export(module.exports, "default", () => $26314a59aa3888f9$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $26314a59aa3888f9$var$messages = (0, $2nPZH.defineMessages)({
    menuItemLoading: {
        id: "navigation.universal-create.menuItemLoading",
        defaultMessage: "Menu item is loading"
    }
});
var $26314a59aa3888f9$export$2e2bcd8739ae039 = $26314a59aa3888f9$var$messages;

});




parcelRegister("etnZD", function(module, exports) {

$parcel$export(module.exports, "TriggerButton", () => $2395bc7d320228d3$export$4129321aecd13375);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $inPa6 = parcelRequire("inPa6");

var $4KS7f = parcelRequire("4KS7f");

var $g5gZt = parcelRequire("g5gZt");

var $lnqHu = parcelRequire("lnqHu");

var $aaBfd = parcelRequire("aaBfd");

var $1lhEF = parcelRequire("1lhEF");
var $5izcQ = parcelRequire("5izcQ");

var $26eSY = parcelRequire("26eSY");

var $3gadb = parcelRequire("3gadb");

var $jjCkw = parcelRequire("jjCkw");
const $2395bc7d320228d3$var$triggerButton = null; /**
                             * Refactor this whole logic after T-25, we should use the proper Create component instead.
                             * https://jplat.atlassian.net/browse/BLU-7401
                             */ 
const $2395bc7d320228d3$var$nav3ButtonTextStyles = null;
function $2395bc7d320228d3$export$4129321aecd13375({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, product: product, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onButtonClick = (0, $gwFzn.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'universalCreateTriggerButton',
            eventType: 'ui',
            tags: [
                'navigationExperiences'
            ],
            attributes: {
                product: product
            }
        });
        analyticsEvent.fire((0, $jjCkw.ANALYTICS_CHANNEL));
        onClick();
    }, [
        createAnalyticsEvent,
        onClick,
        product
    ]);
    const CreateIcon = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt)));
    const button = isNav4Enabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: children,
        isScreenReaderAnnouncementDisabled: true,
        position: "bottom",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aaBfd.Button), {
            ...triggerProps,
            appearance: "primary",
            onClick: onButtonClick,
            isSelected: isOpen,
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)(CreateIcon, {
                    ...iconProps,
                    label: "",
                    testId: `${testId}-icon-temp-do-not-use`
                }),
            testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
            "aria-label": children,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                above: "sm",
                children: children
            })
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4KS7f.default), {
            ...triggerProps,
            appearance: "primary",
            theme: buttonTheme,
            onClick: onButtonClick,
            iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)(CreateIcon, {
                label: "",
                "data-vc": "global-content-create-button"
            }),
            testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
            "aria-label": children,
            isSelected: isOpen,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                above: "sm",
                children: children
            })
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
        ]),
        children: triggerButtonSpotlightTarget ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5izcQ.default), {
            name: triggerButtonSpotlightTarget,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1lhEF.Pulse), {
                radius: 3,
                pulse: enableTriggerPulse,
                children: button
            })
        }) : button
    });
}

});

parcelRegister("lz3e7", function(module, exports) {

$parcel$export(module.exports, "useIsResponsiveView", () => $a714a9fde214d42c$export$2a50c0408cf3ddb8);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $fVdiF = parcelRequire("fVdiF");
const $a714a9fde214d42c$export$f8e186cd2da1abff = 100;
const $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT = 767;
function $a714a9fde214d42c$export$2a50c0408cf3ddb8() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $gwFzn.useState)(window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT);
    const [handleResizeDebounced] = (0, $fVdiF.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT;
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, $a714a9fde214d42c$export$f8e186cd2da1abff);
    (0, $gwFzn.useEffect)(()=>{
        let unbind;
        unbind = (0, $d8F95.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
}

});


parcelRegister("6e99h", function(module, exports) {

$parcel$export(module.exports, "useMenuItems", () => $279d18c421fdc96b$export$aad046bd9909db8f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $de2j9 = parcelRequire("de2j9");

var $dPJCf = parcelRequire("dPJCf");

var $3jwuS = parcelRequire("3jwuS");

var $dEBDF = parcelRequire("dEBDF");

var $ep3mz = parcelRequire("ep3mz");

var $1KBSi = parcelRequire("1KBSi");
var $5xTWd = parcelRequire("5xTWd");

var $yuLaV = parcelRequire("yuLaV");

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $kDja4 = parcelRequire("kDja4");

var $7EIq6 = parcelRequire("7EIq6");

var $fSDMD = parcelRequire("fSDMD");

var $jrwID = parcelRequire("jrwID");

var $dAC7y = parcelRequire("dAC7y");

var $ejGOi = parcelRequire("ejGOi");

var $3LivB = parcelRequire("3LivB");

var $1OVup = parcelRequire("1OVup");

var $fw6FY = parcelRequire("fw6FY");

var $4e5hr = parcelRequire("4e5hr");

var $8hdRZ = parcelRequire("8hdRZ");

var $a26i4 = parcelRequire("a26i4");
const $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $279d18c421fdc96b$var$messages = (0, $2nPZH.defineMessages)({
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu) {
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleAnalyticsAndResetStickySearch = (0, $gwFzn.useCallback)((actionSubjectId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
                attributes: {
                    navdexPointType: (0, $dEBDF.END),
                    isOnEditRoute: isOnEditRoute,
                    currentRouteName: routeDataRef?.current?.routeName,
                    currentRouteIsLive: isLivePage
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isOnEditRoute,
        routeDataRef,
        isLivePage
    ]);
    const onClick = (0, $gwFzn.useCallback)((actionSubjectId)=>{
        handleAnalyticsAndResetStickySearch(actionSubjectId);
        closeMenu?.();
    }, [
        handleAnalyticsAndResetStickySearch,
        closeMenu
    ]);
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled } = (0, $5xTWd.useCreateSpaceExperiment)();
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isCreateSpaceFromGlobalCreateEnabled = canCreateSpace && isSpaceTypesCreationFlowEnabled;
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    const liveDoc = (0, $jrwID.useLiveDocItem)({
        source: 'globalCreateDropdown-liveDoc',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const page = (0, $dAC7y.usePageItem)({
        source: 'globalCreateDropdown-page',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const whiteboard = (0, $ejGOi.useWhiteboardItem)({
        source: 'globalCreateDropdown-whiteboard',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const database = (0, $3LivB.useDatabaseItem)({
        source: 'globalCreateDropdown-database',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const blog = (0, $1OVup.useBlogItem)({
        source: 'globalCreateDropdown-blog',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const embed = (0, $fw6FY.useEmbedItem)({
        source: 'globalCreateDropdown-smartLinkEmbed',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const loom = (0, $8hdRZ.useLoomItem)({
        source: 'globalCreateDropdown-smartLinkEmbed',
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick,
        flags: flags
    });
    const space = (0, $4e5hr.useSpaceItem)({
        source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
        parentId: contentId,
        spaceKey: spaceKey,
        onClick: onClick
    });
    const smartCreate = (0, $a26i4.useAISmartCreateItem)({
        source: 'globalCreateDropdown-smartCreate',
        spaceKey: spaceKey,
        onClick: onClick
    });
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isOptedOutedOfWhiteboards = isWhiteboardFeatureEnabled('whiteboardOptOut');
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    const databaseOptIn = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database') && !(0, $9wGTI.fg)('confluence_frontend_databases_opt-out');
    const nativeItems = {
        items: [
            ...(0, $9wGTI.fg)('confluence_ai_create_menu_item') ? [
                smartCreate
            ] : [],
            ...isCreateLiveDocEnabled && !(0, $6mKj3.expValEquals)('cc_page_modes_live_docs_location_in_creation_menu', 'cohort', 'test') ? [
                liveDoc
            ] : [],
            page,
            ...isCreateLiveDocEnabled && (0, $6mKj3.expValEquals)('cc_page_modes_live_docs_location_in_creation_menu', 'cohort', 'test') ? [
                liveDoc
            ] : [],
            ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                whiteboard
            ] : [],
            ...isCreateDatabaseEnabled && databaseOptIn ? [
                database
            ] : [],
            ...isCreateBlogEnabled ? [
                blog
            ] : [],
            ...isCreateSmartLinkEnabled ? [
                embed
            ] : [],
            ...isCreateSpaceFromGlobalCreateEnabled ? [
                space
            ] : []
        ]
    };
    const menuItems = [
        nativeItems
    ];
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    if (isCreateSmartLinkEnabled && isLoomEntryPointEnabled) menuItems.push({
        heading: formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian),
        items: [
            loom
        ]
    });
    return menuItems;
}

});
parcelRegister("jrwID", function(module, exports) {

$parcel$export(module.exports, "useLiveDocItem", () => $27cf2e1d8d21e923$export$5af7ed73ba9cf3af);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $e0ycV = parcelRequire("e0ycV");

var $3w0K2 = parcelRequire("3w0K2");

var $lqy4C = parcelRequire("lqy4C");

var $8Qafc = parcelRequire("8Qafc");

var $dilhZ = parcelRequire("dilhZ");

var $3J7nf = parcelRequire("3J7nf");

var $dPJCf = parcelRequire("dPJCf");

var $dIouf = parcelRequire("dIouf");

var $bZSO8 = parcelRequire("bZSO8");

var $bBaUQ = parcelRequire("bBaUQ");

var $gPB5e = parcelRequire("gPB5e");

var $jo6R7 = parcelRequire("jo6R7");
const $27cf2e1d8d21e923$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.liveDoc.new.lozenge",
        defaultMessage: "New"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
    });
    const createHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        subType: (0, $gPB5e.ConfluencePageSubType).LIVE,
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    });
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createLiveDocPopoverItem');
        hybridLinkClick(e);
    };
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { introSpotlight: introSpotlight, error: error } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: shouldShowIntroSpotlight, complete: completeIntroSpotlight } = introSpotlight;
    const [hasFiredOnStartEvent, setHasFiredOnStartEvent] = (0, $gwFzn.useState)(false);
    const onSpotlightStart = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'liveDocIntro',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldShowIntroSpotlight && !hasFiredOnStartEvent) {
            onSpotlightStart();
            setHasFiredOnStartEvent(true);
        }
    }, [
        shouldShowIntroSpotlight,
        hasFiredOnStartEvent,
        onSpotlightStart
    ]);
    const LiveDocSpotlightWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8Qafc.CreateButtonSpotlightPulseWrapper), {
            condition: shouldShowIntroSpotlight,
            wrapper: (element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dilhZ.CreateLiveDocPopoverItemSpotlight), {
                    handleDismiss: ()=>{
                        completeIntroSpotlight();
                    },
                    handleProceed: enforceStorageLimit((e)=>{
                        completeIntroSpotlight();
                        handleClick(e);
                        push(createHref);
                    }),
                    targetName: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM,
                    source: source,
                    fireAnalyticsEventOnMessageDisposition: false
                }, element, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                    error: error
                }))
        }, children());
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:livedoc'),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
            lozenge: formatMessage($27cf2e1d8d21e923$var$messages.newLozenge)
        }, formatMessage($27cf2e1d8d21e923$var$messages.title)),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        Wrapper: LiveDocSpotlightWrapper,
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}

});
parcelRegister("jo6R7", function(module, exports) {

$parcel$export(module.exports, "ItemTitleWithLozenge", () => $925aeaac5c2ec2fe$export$32629a9f34b6d093);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $5nBzc = parcelRequire("5nBzc");
const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = ({ children: children, lozenge: lozenge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
        appearance: "new"
    }, lozenge));

});


parcelRegister("dAC7y", function(module, exports) {

$parcel$export(module.exports, "usePageItem", () => $f6498381976d168b$export$e324b86258d66a8f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $8jHAi = parcelRequire("8jHAi");

var $3w0K2 = parcelRequire("3w0K2");

var $lqy4C = parcelRequire("lqy4C");

var $bZSO8 = parcelRequire("bZSO8");

var $bBaUQ = parcelRequire("bBaUQ");
const $f6498381976d168b$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-page-popover-item'
    });
    const createHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    });
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        onClick('createPagePopoverItem');
        hybridPageLinkClick(e);
    }, [
        onClick,
        hybridPageLinkClick
    ]);
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:page'),
        children: formatMessage($f6498381976d168b$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}

});

parcelRegister("ejGOi", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardItem", () => $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ZDq1z = parcelRequire("ZDq1z");

var $inPa6 = parcelRequire("inPa6");

var $3w0K2 = parcelRequire("3w0K2");

var $irVI7 = parcelRequire("irVI7");
var $gfIPU = parcelRequire("gfIPU");
var $ln0hx = parcelRequire("ln0hx");

var $lqy4C = parcelRequire("lqy4C");

var $eVXGa = parcelRequire("eVXGa");

var $8aF6s = parcelRequire("8aF6s");

var $lv5Bc = parcelRequire("lv5Bc");
var $gUusY = parcelRequire("gUusY");

var $8fj5s = parcelRequire("8fj5s");

var $bZSO8 = parcelRequire("bZSO8");

var $bBaUQ = parcelRequire("bBaUQ");

var $5nX81 = parcelRequire("5nX81");

var $fCfQ7 = parcelRequire("fCfQ7");

var $98wxI = parcelRequire("98wxI");
const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT = 'cc-whiteboard-nudge-global-create-experiment';
const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM = 'globalCreateCohort';
const $10e7e2c648ba4dd0$export$118062d2c7c760ca = {
    experimentName: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT,
    cohort: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM
};
const $10e7e2c648ba4dd0$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
function $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    // const { accessStatus } = useSessionData();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-whiteboard-popover-item'
    });
    const buildWhiteboardCreationLink = (creationOverrides = {}, sourceSuffix = '')=>{
        return (0, $bZSO8.buildCreationLink)({
            contentType: 'whiteboard',
            parentPageId: parentId,
            withFallback: true,
            source: source + sourceSuffix,
            spaceKey: spaceKey,
            deactivationIdentifier: deactivationIdentifier,
            paywallStatus: paywallStatus,
            ...creationOverrides
        });
    };
    const createHref = buildWhiteboardCreationLink();
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createWhiteboardPopoverItem');
        if (showPaywallBeforeCreate) showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
            buildWhiteboardCreationLink: buildWhiteboardCreationLink
        });
        else {
            if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'createUnsetWhiteboardLink',
                    source: source,
                    attributes: {
                        reason: creationPaywallError ? 'error' : 'loading'
                    }
                }
            }).fire();
            hybridLinkClick(e);
        }
    };
    // TODO: add tooltip back post T25
    // const getTooltipContent = (accessStatusArg: AccessStatus | null): string | undefined => {
    // 	if (!isAllowedToCreateWhiteboard) {
    // 		if (accessStatusArg === null) {
    // 			return formatMessage(messages.toolTipTextAnonymous);
    // 		} else {
    // 			return formatMessage(messages.toolTipTextUnlicensed);
    // 		}
    // 	}
    // 	return undefined;
    // };
    // const toolTipContent = getTooltipContent(accessStatus);
    // Whiteboard Nudge Campaign Experiment
    const { getExperiment: getExperiment, skipCoordinationClientForExperiment: skipCoordinationClientForExperiment } = (0, $gUusY.useWhiteboardNudgeExperiments)($10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT, $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM);
    const [isWhiteboardExperimentationSpotlightActive, stopWhiteboardExperimentationSpotlight] = (0, $8fj5s.useSkippableCoordination)('cc-whiteboards-nudge-exp-spotlight-v2', shouldBlockCreate || skipCoordinationClientForExperiment);
    const [isSpotlightOpen, setIsSpotlightOpen] = (0, $gwFzn.useState)(true);
    const isEligibleToSeeSpotlight = isWhiteboardExperimentationSpotlightActive && getExperiment($10e7e2c648ba4dd0$export$118062d2c7c760ca['experimentName'], $10e7e2c648ba4dd0$export$118062d2c7c760ca['cohort'], true) === 'variation';
    const handleSpotlightClose = (0, $gwFzn.useCallback)(()=>{
        setIsSpotlightOpen(false);
        stopWhiteboardExperimentationSpotlight();
    }, [
        stopWhiteboardExperimentationSpotlight,
        setIsSpotlightOpen
    ]);
    const WhiteboardSpotlightWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lv5Bc.CreateWhiteboardExperimentPopoverItemSpotlight), {
            createHref: createHref,
            spotlightDialogPlacement: "right middle",
            handleSpotlightClose: handleSpotlightClose,
            handleClosePopoverMenu: handleClick,
            source: source,
            shouldWatchTarget: true
        }, children());
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:whiteboard'),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        }), formatMessage($10e7e2c648ba4dd0$var$messages.title)),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        ...!shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        },
        ...isSpotlightOpen && isEligibleToSeeSpotlight && isAllowedToCreateWhiteboard && {
            Wrapper: WhiteboardSpotlightWrapper
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}

});

parcelRegister("3LivB", function(module, exports) {

$parcel$export(module.exports, "useDatabaseItem", () => $c6e82055c002803e$export$c03ba1b69410a0fd);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6B0jU = parcelRequire("6B0jU");

var $3w0K2 = parcelRequire("3w0K2");

var $lqy4C = parcelRequire("lqy4C");

var $gkP7d = parcelRequire("gkP7d");

var $8fj5s = parcelRequire("8fj5s");

var $bZSO8 = parcelRequire("bZSO8");

var $bBaUQ = parcelRequire("bBaUQ");
const $c6e82055c002803e$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $c6e82055c002803e$export$c03ba1b69410a0fd({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-database-popover-item'
    });
    const createContentOptions = {
        contentType: 'database',
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    };
    const [isSpotlightOpen, setIsSpotlightOpen] = (0, $gwFzn.useState)(true);
    const [isDatabaseGAOnboardingActive, stopDatabaseGAOnboarding] = (0, $8fj5s.useSkippableCoordination)('cc-databases-ga-create-spotlight', shouldBlockCreate);
    const handleSpotlightClose = (0, $gwFzn.useCallback)(()=>{
        setIsSpotlightOpen(false);
        stopDatabaseGAOnboarding();
    }, [
        stopDatabaseGAOnboarding
    ]);
    const createHref = (0, $bZSO8.buildCreationLink)(createContentOptions);
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createDatabasePopoverItem');
        hybridPageLinkClick(e);
    };
    const DatabaseSpotlightWrapper = ({ children: children })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gkP7d.CreateDatabaseGAPopoverItemSpotlight), {
            createHref: createHref,
            source: source,
            onClose: handleSpotlightClose,
            dialogPlacement: "right middle",
            shouldWatchTarget: true
        }, children());
    };
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:database'),
        children: formatMessage($c6e82055c002803e$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        ...isSpotlightOpen && isDatabaseGAOnboardingActive && {
            Wrapper: DatabaseSpotlightWrapper
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}

});

parcelRegister("1OVup", function(module, exports) {

$parcel$export(module.exports, "useBlogItem", () => $b66cd3653b467139$export$1850e31ba3eb45b0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9RVmI = parcelRequire("9RVmI");

var $3w0K2 = parcelRequire("3w0K2");

var $lqy4C = parcelRequire("lqy4C");

var $bZSO8 = parcelRequire("bZSO8");

var $bBaUQ = parcelRequire("bBaUQ");
const $b66cd3653b467139$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0({ source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-blog-popover-item'
    });
    const createHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'blog',
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    });
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        onClick('createBlogPopoverItem');
        hybridPageLinkClick(e);
    }, [
        onClick,
        hybridPageLinkClick
    ]);
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:blogpost'),
        children: formatMessage($b66cd3653b467139$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}

});

parcelRegister("fw6FY", function(module, exports) {

$parcel$export(module.exports, "useEmbedItem", () => $2e6ededdd99584ac$export$da2a30a64353a280);

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $duwSm = parcelRequire("duwSm");

var $3w0K2 = parcelRequire("3w0K2");

var $lqy4C = parcelRequire("lqy4C");

var $bZSO8 = parcelRequire("bZSO8");

var $bBaUQ = parcelRequire("bBaUQ");
const $2e6ededdd99584ac$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $2e6ededdd99584ac$export$da2a30a64353a280({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-smart-link-embed-popover-item'
    });
    const createContentOptions = {
        contentType: 'smartLinkEmbed',
        parentPageId: parentId,
        withFallback: true,
        source: source,
        spaceKey: spaceKey
    };
    const createHref = (0, $bZSO8.buildCreationLink)(createContentOptions);
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (e)=>{
        onClick('createSmartLinkEmbedPopoverItem');
        hybridPageLinkClick(e);
    };
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:embed'),
        children: formatMessage($2e6ededdd99584ac$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($duwSm))),
        ...!shouldBlockCreate && {
            href: createHref
        },
        testId: `create-menu-${shouldBlockCreate ? 'button' : 'link'}-item`
    };
}

});

parcelRegister("4e5hr", function(module, exports) {

$parcel$export(module.exports, "useSpaceItem", () => $293cf5b691bb25ab$export$4adf07b2777336fa);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $buthI = parcelRequire("buthI");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");

var $3w0K2 = parcelRequire("3w0K2");

var $lBYCH = parcelRequire("lBYCH");

var $lqy4C = parcelRequire("lqy4C");

var $bAyaS = parcelRequire("bAyaS");

var $eSLr0 = parcelRequire("eSLr0");
var $4vyfK = parcelRequire("4vyfK");
const $293cf5b691bb25ab$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $gwFzn.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $gwFzn.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        resetStickySearchRef,
        source
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}

});

parcelRegister("8hdRZ", function(module, exports) {

$parcel$export(module.exports, "useLoomItem", () => $3e0600a499c498b6$export$2c423d86f10c527b);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $2Yaht = parcelRequire("2Yaht");

var $jojoK = parcelRequire("jojoK");

var $3w0K2 = parcelRequire("3w0K2");

var $8Q0mA = parcelRequire("8Q0mA");
var $f5Ulo = parcelRequire("f5Ulo");
var $4R3wx = parcelRequire("4R3wx");
var $9uAPw = parcelRequire("9uAPw");

var $lqy4C = parcelRequire("lqy4C");

var $dPJCf = parcelRequire("dPJCf");

var $7QM6o = parcelRequire("7QM6o");

var $lJxO6 = parcelRequire("lJxO6");

var $8fj5s = parcelRequire("8fj5s");

var $9wGTI = parcelRequire("9wGTI");

var $bZSO8 = parcelRequire("bZSO8");

var $jo6R7 = parcelRequire("jo6R7");
const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(error, loading) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const href = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const PopupWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
            description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
            entryPointId: "loom-confluence-create-menu",
            shouldRenderToParent: false,
            title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
            sourceActionSubjectId: "createLoomPopoverItem",
            triggerLink: (_, triggerProps)=>children({
                    triggerProps: triggerProps
                })
        });
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:loom-cross-join'),
        ...!error && !loading && {
            href: href
        },
        isLoading: loading,
        target: '_blank',
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
            lozenge: formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge)
        }, formatMessage($3e0600a499c498b6$var$messages.title)),
        Wrapper: PopupWrapper,
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht)))
    };
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = ({ parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
        flags: flags
    });
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'record-loom-popover-item'
    });
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        onClick('createLoomPopoverItem');
        openLoomRecorder({
            onInsert: (videoUrl)=>{
                const createUrl = (0, $bZSO8.buildCreationLink)({
                    contentType: 'smartLinkEmbed',
                    parentPageId: parentId,
                    withFallback: true,
                    smartLinkCreateSource: 'loomRecordSDK',
                    smartLinkEmbedUrl: videoUrl,
                    source: source,
                    spaceKey: spaceKey
                });
                push(createUrl);
                (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'insertVideo',
                            actionSubject: 'loom',
                            source: source,
                            objectType: 'embed',
                            containerType: 'space',
                            containerId: spaceId,
                            attributes: {
                                location: 'contentTreeItem',
                                video_id: hashedVideoId
                            }
                        }
                    }).fire();
                });
            },
            // intentionally not localized because Loom RecordSDK does not support i18n
            insertButtonText: 'Insert video',
            location: 'topNav'
        });
    }, [
        onClick,
        openLoomRecorder,
        parentId,
        source,
        spaceKey,
        push,
        createAnalyticsEvent,
        spaceId
    ]);
    const shouldShowLoomGAOnboarding = isLoomRecorderInitialized && hasRecordingAccess && (0, $9wGTI.fg)('confluence_m25_onboarding_spotlights');
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)('cc-loom-onboarding-spotlight-creation', !shouldShowLoomGAOnboarding || shouldBlockCreate);
    const [isGASpotlightOpen, setIsGASpotlightOpen] = (0, $gwFzn.useState)(true);
    const handleSpotlightClose = (0, $gwFzn.useCallback)(()=>{
        if (isLoomGAOnboardingActive) {
            setIsGASpotlightOpen(false);
            stopLoomGAOnboarding();
        }
    }, [
        stopLoomGAOnboarding,
        isLoomGAOnboardingActive
    ]);
    const RecordLoomSpotlightWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lJxO6.RecordLoomPopoverItemSpotlight), {
            onRecord: enforceStorageLimit(handleClick),
            onClose: handleSpotlightClose,
            source: source,
            shouldWatchTarget: true
        }, children());
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:video'),
        children: formatMessage($3e0600a499c498b6$var$messages.title),
        isLoading: !isLoomRecorderInitialized,
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
        onClick: enforceStorageLimit(handleClick),
        ...shouldShowLoomGAOnboarding && isLoomGAOnboardingActive && isGASpotlightOpen && {
            Wrapper: RecordLoomSpotlightWrapper
        }
    };
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(error, loading);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}

});

parcelRegister("a26i4", function(module, exports) {

$parcel$export(module.exports, "useAISmartCreateItem", () => $03068ae1a528f6bf$export$57669fd702f839a2);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $e2ZTm = parcelRequire("e2ZTm");

var $3w0K2 = parcelRequire("3w0K2");

var $1NBp8 = parcelRequire("1NBp8");

var $hp2SH = parcelRequire("hp2SH");

var $bBaUQ = parcelRequire("bBaUQ");

var $5w6h6 = parcelRequire("5w6h6");
const $03068ae1a528f6bf$var$i18n = (0, $2nPZH.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create.title",
        defaultMessage: "Get started with AI"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $hp2SH.getApolloClient)().query({
        query: (0, $5w6h6.GetPromotedSpacesQuery),
        variables: spaceKeyRequest
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2({ spaceKey: spaceKey, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $gwFzn.useState)('');
    // Promoted Spaces query should be cached, but we do have a race condition here for global create where there
    // can potentially be missing space key. This is fine for the early spike stage.
    (0, $gwFzn.useEffect)(()=>{
        $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey);
    }, []);
    const createHref = (0, $1NBp8.SMART_CREATE_PROMPT).toUrl(undefined, {
        query: {
            spaceKey: spaceKey ?? fetchedSpaceKey
        }
    });
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        onClick('createAISmartCreatePopoverItem');
        hybridPageLinkClick(e);
    }, [
        onClick,
        hybridPageLinkClick
    ]);
    return {
        ati: (0, $3w0K2.Ati).parse('ati:cloud:confluence:page'),
        // todo: this is incorrect, we don't know the type identifier yet
        children: formatMessage($03068ae1a528f6bf$var$i18n.smartCreateTitle),
        onClick: handleClick,
        elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e2ZTm))),
        href: createHref,
        testId: `create-menu-link-item`
    };
}

});



parcelRegister("gfjK8", function(module, exports) {

let $bd3d5ca5c4837922$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bd3d5ca5c4837922$var$load("i2OFv"),
    $bd3d5ca5c4837922$var$load("iMSgb"),
    $bd3d5ca5c4837922$var$load("joJy8"),
    $bd3d5ca5c4837922$var$load("aHE9G"),
    $bd3d5ca5c4837922$var$load("ffEVr"),
    $bd3d5ca5c4837922$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});



//# sourceMappingURL=CreateComponent.ca50792b.js.map
